import { render, staticRenderFns } from "./CustomerAccessDrawer.vue?vue&type=template&id=8ab28118&"
import script from "./CustomerAccessDrawer.vue?vue&type=script&lang=js&"
export * from "./CustomerAccessDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports